import { Tabs, type TabsOptionProps } from '@sqs/rosetta-elements';
import React, { useContext, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { FEATURE_FLAGS } from '../../const/feature-flags';
import {
  NAV_SETTINGS,
  NAV_SETTINGS_API_KEY,
  NAV_SETTINGS_ORGANIZATION,
  NAV_SETTINGS_SSO } from
'../../const/navigation';
import { useI18n } from '../../i18n';
import { RootState } from '../../stores/rootReducer';
import { useAppSelector } from '../../stores/store';
import { FeatureFlagContext } from '../FeatureFlagProvider';
import { PageHeader } from '../PageHeader';

export const Settings = () => {
  const { t } = useI18n();
  const location = useLocation();
  const navigate = useNavigate();
  const { flagEnabled } = useContext(FeatureFlagContext);

  let currentTabFromLocation = location.pathname;
  if (location.pathname === NAV_SETTINGS) {
    currentTabFromLocation = NAV_SETTINGS_ORGANIZATION;
  }
  const { isLoading } = useAppSelector((state: RootState) => ({
    isLoading: state.currentUser.isLoading
  }));
  const canUserUseSso = flagEnabled(FEATURE_FLAGS.ENTERPRISE_SHOW_SSO_IN_DASHBOARD);

  const [currentTab, setCurrentTab] = useState(currentTabFromLocation);

  const tabOptions: TabsOptionProps[] = [
  {
    label: t("Organization", null, { project: 'enterprise-dashboard' }),
    value: NAV_SETTINGS_ORGANIZATION,
    sx: { marginRight: '60px' }
  },
  {
    label: t("API Key", null, { project: 'enterprise-dashboard' }),
    value: NAV_SETTINGS_API_KEY,
    sx: { marginRight: '60px' }
  }];

  if (canUserUseSso) {
    // tabOptions;tabOptions
    tabOptions.splice(1, 0, {
      label: t("SSO", null, { project: 'enterprise-dashboard' }),
      value: NAV_SETTINGS_SSO,
      sx: { marginRight: '60px' }
    });
  }

  return (
    <div aria-live="polite" aria-busy={isLoading}>
      <PageHeader title={t("Settings", {}, { project: 'enterprise-dashboard' })} />
      <Tabs
        htmlAttributes={{ css: { '&:before': { height: 0 } } }}
        options={tabOptions}
        value={currentTab}
        onChange={(value: string) => {
          setCurrentTab(value);
          navigate(value);
        }} />

      <Outlet />
    </div>);

};